import React, { useCallback, useRef, useState } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { UI_MSG } from "../../config/uiMessages";

/**
 * Map shell with tile-failure notice (MapTiler / network).
 * Non-breaking: same MapContainer API as before via children.
 */
export default function MapCanvas({
  center = [51.37, -0.22],
  zoom = 12,
  children,
}) {
  const [tilesFailed, setTilesFailed] = useState(false);
  const errorCountRef = useRef(0);
  const recoveredRef = useRef(false);

  const onTileError = useCallback(() => {
    if (recoveredRef.current) return;
    errorCountRef.current += 1;
    // A single flaky tile shouldn't alarm; a burst usually means tiles are down
    if (errorCountRef.current >= 3) setTilesFailed(true);
  }, []);

  const onTileLoad = useCallback(() => {
    recoveredRef.current = true;
    errorCountRef.current = 0;
    setTilesFailed(false);
  }, []);

  return (
    <div className="v2-map-canvas-root">
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          url="https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=zevAZr89M5ksx2bRpvOF"
          attribution="© MapTiler © OpenStreetMap contributors"
          tileSize={256}
          zoomOffset={0}
          eventHandlers={{
            tileerror: onTileError,
            tileload: onTileLoad,
          }}
        />
        {children}
      </MapContainer>

      {tilesFailed ? (
        <div className="v2-map-tile-alert" role="alert">
          {UI_MSG.MAP_TILES_FAILED}
        </div>
      ) : null}
    </div>
  );
}
